export enum RoundStatus {
  Pending = 1,
  Started,
  OnHold,
  OnFinish,
  Finished,
  Cancelled,
}
